const isProd = process.env.NODE_ENV === "production";
const uuc_prod_url = "https://uuc.it.czczh.cn/gw/novauc/";
export const host = isProd ? location.host : process.env.VUE_APP_BASE_HOST;
export const uuc_api = isProd
  ? uuc_prod_url
  : process.env.VUE_APP_UUC_BASE_HOST || uuc_prod_url;

//"https://192.168.2.234/uuc-gw/9000/novauc/";
console.log("host", host, uuc_api);
